import { render, staticRenderFns } from "./SaveOrCancel.vue?vue&type=template&id=1346d41a&scoped=true"
import script from "./SaveOrCancel.vue?vue&type=script&lang=js"
export * from "./SaveOrCancel.vue?vue&type=script&lang=js"
import style0 from "./SaveOrCancel.vue?vue&type=style&index=0&id=1346d41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346d41a",
  null
  
)

export default component.exports